// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/aboutus-hreo-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutUs_container {
    color: #FFFFFF;

}

.aboutUs_section1_container {
    background-color: #012D01;
    /* height: 1000px; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 40px 50px 50px 50px;
    z-index: 3;
}

.aboutUs_section1_column1 {
    background-color: rgba(92, 191, 20, 0.4);
    border-radius: 15px;
    height: 220px;
    padding: 0 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 70px;
}

.aboutUs_section1_heading,
.aboutUs_section1_column2_text1,
.aboutUs_section2_column1p,
.aboutUs_section3_part1p {
    font-weight: 400 !important;
    font-size: 20px !important;
    line-height: 24.46px !important;
    color: #EAAD11 !important;
}

.aboutUs_section1_column1_flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.aboutUs_section1_column1_flexh3 {
    font-weight: 700 !important;
    font-size: 48px !important;
    line-height: 65px !important;
    color: #FFFFFF !important;
}

.aboutUs_section1_column1_flexp {
    width: 550px !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    line-height: 27.52px !important;
    color: #FFFFFF !important;
}

.aboutUs_section1_column2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 722px;
    height: 408px;
    margin: auto;
    padding-top: 100px;
}

.policy_row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* height: 408px; */
    margin: auto;
    padding-top: 30px;
}

.policy_text2 {
    display: flex;
    font-size: 18px;
    line-height: 35px;
    width: 100%;
    text-align: left;
   
}

.aboutUs_section1_column2_h3 {
    font-weight: 700;
    font-size: 48px;
    list-style: 60px;
    padding-top: 10px;
    padding-bottom: 20px;
}

.aboutUs_section1_column2_text2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 35px;
    width: 722px;
    height: 280px;

}

.aboutUs_section2_container {
    display: flex;
    padding-top: 150px;
    gap: 50px;
}

.aboutUs_section2_column1 {
    width: 424px;
    height: 203px;
}

.aboutUs_section2_column1h4 {
    font-weight: 400;
    font-size: 30px;
    line-height: 55px;
    width: 424px;
    height: 165px;
}

.abouthr_line {
    width: 271px;
    height: 6px;
    border-radius: 15px;
    background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);
    border: none;
}

.aboutUs_section2_column2 {
    display: flex;
    gap: 20px;
}

.aboutusgallery2_img {
    display: flex;
    flex-direction: column;
    gap: 40px;
}


.aboutusCustosolu_container {
    display: flex;
    gap: 10px;
}

.aboutusgallery2Head_common {
    font-weight: 700;
    font-size: 24px;
    line-height: 33.1px;

}

.aboutusgallery2Text_common {
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    width: 401px;
    height: 112px;
}

.aboutUs_section3_container {
    height: 550px;
    background-color: #033d03;
    position: relative;
    padding: 0 50px;
}

.aboutUs_section3_part1_container {
    width: 598px;
    height: 417px;
    padding-top: 60px;
}

.aboutUs_section3 {
    padding-top: 50px;
}

.aboutUs_section3Head_common {
    font-size: 40px;
    font-weight: 700;
    line-height: 55px;

}

.aboutUs_section3Text_common {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    width: 541px;
    height: 24px
}

.aboutUs_section4_container {
    height: 860px;
    background-color: #012D01;
    padding: 0 50px;

}

.aboutUs_section4_part1 {
    width: 402px;
    height: 109px;
    padding-top: 70px;

}

.aboutUs_section4_part1p {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #EAAD11;
}

.aboutUs_section4_part1h4 {
    font-size: 36px;
    font-weight: 700;
    line-height: 55px;

}

.aboutUs_section4_part2_gallery {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding-top: 150px;
    padding-bottom: 100px;
}

.aboutUs_section4_part2_gallery_container {
    position: relative;
    overflow: hidden;
    border-radius: 15px;
}


.aboutUs_section4_img_wrapper {
    position: relative;
    width: 100%;
}

.aboutUs_section4_img_wrapper img {
    border-radius: 14px;
    width: 100%;
}

.aboutUs_section4_img_overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    opacity: 0;
    transition: height 0.8s ease, opacity 0.8s ease;
}

.aboutUs_section4_part2_gallery_container:hover .aboutUs_section4_img_overlay {
    height: 100%;
    /* Increase the height to 100% on hover */
    opacity: 1;

}

.aboutUs_section4_img_overlay_text {
    background-color: #EAAD11;
    color: #000000;
    width: 100%;
    overflow: hidden;
    text-align: center;
    height: 30%;
    padding: 20px 0;

}

.aboutUs_section4_img_overlay_texth3 {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
}

.aboutUs_section4_img_overlay_textp {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-transform: uppercase;
}

.aboutusBtn_container {
    width: 196px;
    margin: auto;
}


@media screen and (max-width: 1050px) {
    .aboutUs_section2_container {
        display: flex;
        padding-top: 150px;
        gap: 20px;
    }

    .aboutUs_section2_column1 {
        width: 350px;
        height: 203px;
    }

    .aboutUs_section2_column1h4 {
        font-weight: 400;
        font-size: 24px;
        line-height: 55px;
        width: 320px;
    }

    .abouthr_line {
        width: 251px;
        height: 6px;
        border-radius: 15px;
        background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);
        border: none;
    }


    .aboutusgallery2_img {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .aboutusgallery1_img img {
        width: 270px;
    }

    .aboutusgallery2_img_aboutgallery2_img {
        width: 280px;
    }

    .aboutus_custo_col {
        width: 220px;
    }

    .aboutus_custo_img {
        width: 35px;
        height: 35px;
    }

    .aboutusCustosolu_container {
        display: flex;
    }

    .aboutusgallery2Head_common {
        font-weight: 700;
        font-size: 23px;
        line-height: 33.1px;

    }

    .aboutusgallery2Text_common {
        font-weight: 400;
        font-size: 17px;
        line-height: 26.52px;
        width: 240px;
        height: 112px;
    }


    /* Section 4 */

    .aboutUs_section4_container {
        height: 800px;
        background-color: #012D01;
        padding: 0 50px;

    }

    .aboutUs_section4_part2_gallery img {
        width: 170px;
    }

    .aboutUs_section4_img_overlay_texth3 {
        font-size: 15px;
    }

    .aboutUs_section4_img_overlay_textp {
        font-size: 15px;
    }

    .aboutUs_section4_img_overlay_text {
        height: 38%;
        padding: 15px 0;
    }


}

@media screen and (max-width: 900px) {

    .aboutUs_section1_column1 {
        padding: 0 20px !important;

    }

    .aboutUs_section1_heading,
    .aboutUs_section1_column2_text1,
    .aboutUs_section2_column1p,
    .aboutUs_section3_part1p {
        font-size: 14px !important;
    }

    .aboutUs_section1_column1_flexh3 {
        font-size: 30px !important;
    }

    .aboutUs_section1_column1_flexp {
        width: 400px !important;
        font-size: 15px !important;
    }

    .aboutUs_section1_column2 {
        width: 522px;
    }

    .aboutUs_section1_column2_h3 {
        font-size: 30px;
    }

    .aboutUs_section1_column2_text2 {
        font-size: 16px;
        width: 622px;
    }


    .aboutUs_section2_container {
        gap: 30px;
    }

    .aboutUs_section2_column1 {
        width: 230px;
        height: 300px;
    }

    .aboutUs_section2_column1h4 {
        font-size: 18px;
        line-height: 48px;
        width: 230px;
        height: 160px;

    }

    .abouthr_line {
        width: 180px;
    }


    .aboutusgallery1_img img {
        width: 190px;
    }

    .aboutusgallery2_img_aboutgallery2_img {
        width: 210px;
    }

    .aboutus_custo_col {
        width: 170px;
    }

    .aboutus_custo_img {
        width: 31px;
        height: 33px;
    }


    .aboutusgallery2Head_common {
        font-weight: 700;
        font-size: 17px;
        line-height: 31.1px;

    }

    .aboutusgallery2Text_common {
        font-weight: 400;
        font-size: 13px;
        line-height: 24.52px;
        width: 170px;
        height: 170px;
    }

    .aboutUs_section4_container {
        height: 660px;

    }

    .aboutUs_section4_part1p {
        font-size: 16px;

    }

    .aboutUs_section4_part1h4 {
        font-size: 30px;

    }

    .hr_rule_dir {
        width: 200px;
    }

    .aboutUs_section4_part2_gallery img {
        width: 120px;
    }

    .aboutUs_section4_img_overlay_texth3 {
        font-size: 12px;
    }

    .aboutUs_section4_img_overlay_textp {
        font-size: 12px;
    }

    .aboutUs_section4_img_overlay_text {
        height: 45%;
        padding: 5px;
    }

}

@media screen and (max-width: 500px) {

    .aboutUs_section1_container {
        background-color: #012D01;
        height: 1550px !important;
        padding: 30px !important;
    }

    .privacy_policy_container {
        height: 100% !important;
    }

    .aboutUs_section1_column1 {
        background-color: rgba(92, 191, 20, 0.4) !important;
        border-radius: 15px !important;
        height: 244px !important;
        width: 100% !important;
        display: flex !important;
        flex-direction: column !important;

    }

    .aboutUs_section1_heading,
    .aboutUs_section1_column2_text1,
    .aboutUs_section2_column1p,
    .aboutUs_section3_part1p {
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 24.46px !important;
        color: #EAAD11 !important;

    }


    .aboutUs_section1_column1_flex {
        display: flex !important;
        flex-direction: column !important;
        justify-content: flex-start !important;

    }

    .aboutUs_section1_column1_flexh3 {
        font-weight: 700 !important;
        font-size: 23px !important;
        line-height: 65px !important;
        width: 100% !important;
    }

    .aboutUs_section1_column1_flexp {
        width: 300px !important;
        font-weight: 700 !important;
        font-size: 14px !important;
        line-height: 21.41px !important;
        width: 100% !important;
    }

    .aboutUs_section1_column2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;

    }

    .aboutUs_section1_column2_h3 {
        font-weight: 700;
        font-size: 24px;
        list-style: 60px;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .aboutUs_section1_column2_text2 {
        font-weight: 400;
        font-size: 16px;
        line-height: 35px;
        width: 100%;
        margin-bottom: 50px;

    }

    .policy_text2 {
        font-size: 16px;
    }

    /* Start Here*/


    .aboutUs_section2_container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 150px;
        gap: 0px;
        /* margin-top: 30px; */
    }

    .aboutUs_section2_column1 {
        width: 100%;
        height: 155px;
    }

    .aboutUs_section2_column1h4 {
        font-weight: 700;
        font-size: 19px;
        line-height: 32px;
        width: 370px;
        height: 96px;
    }

    .abouthr_line {
        width: 138px;
        height: 6px;
        border-radius: 15px;
        background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);
        border: none;
    }

    .aboutusgallery1_img img {
        display: none;
    }

    .aboutusgallery2_img_aboutgallery2_img {
        width: 100%;
    }

    .aboutUs_section2_column2 {
        display: flex;
        flex-direction: column;
        gap: 20px;
        /* width: 100%; */
    }

    .aboutusgallery2_img {
        display: flex;
        flex-direction: column;
        gap: 40px;
    }


    .aboutusCustosolu_container {
        display: flex;
        gap: 10px;
    }

    .aboutus_custo_col {
        width: 100%;
    }

    .aboutusgallery2Head_common {
        font-weight: 700;
        font-size: 18px;
        line-height: 24.82px;

    }

    .aboutusgallery2Text_common {
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        width: 100%;
        height: 96px;
    }


    .aboutUs_section3_part1_container {
        width: 598px;
        height: 417px;
        padding-top: 60px;
    }

    .aboutUs_section3 {
        padding-top: 50px;
        height: 130px;
    }

    .aboutUs_section3Head_common {
        font-size: 18px;
        font-weight: 700;
        line-height: 24.82px;

    }

    .aboutUs_section3Text_common {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        width: 300px;
        height: 48px
    }

    .aboutUs_section4_container {
        height: 2270px;
        background-color: #012D01;
        padding: 0 30px;
    }

    .aboutUs_section4_part1 {
        width: 100%;
    }

    .aboutUs_section4_part1p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24.46px;
        color: #EAAD11;
        text-align: center;
    }

    .aboutUs_section4_part1h4 {
        font-size: 24px;
        font-weight: 700;
        line-height: 55px;
        text-align: center;
    }

    .hr_rule_dir {
        width: 160px;
        margin: auto;
    }

    .aboutUs_section4_part2_gallery {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        padding-top: 150px;
        padding-bottom: 100px;
        width: 100%;
    }

    .aboutUs_section4_img_wrapper img {
        width: 100%;
    }

    .aboutUs_section4_img_overlay_text {
        background-color: #EAAD11;
        color: #000000;
        width: 100%;
        overflow: hidden;
        text-align: center;
        height: 30%;
        padding: 20px 0;
    }

    .aboutUs_section4_img_overlay_texth3 {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    .aboutUs_section4_img_overlay_textp {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-transform: uppercase;
    }

    .aboutUs_section4_img_wrapper_img {
        width: 100%;
    }


}


@media screen and (max-width: 400px) {

    .aboutUs_section1_container {
        background-color: #012D01;
        height: 1500px;
        padding: 30px;
    }

    .aboutUs_section1_column1 {
        height: 300px !important;
    }

    .aboutUs_section1_heading,
    .aboutUs_section1_column2_text1,
    .aboutUs_section2_column1p,
    .aboutUs_section3_part1p {
        font-size: 15px !important;
    }


    .aboutUs_section1_column1_flexh3 {
        font-size: 18px !important;

    }

    .aboutUs_section1_column1_flexp {
        font-size: 13px !important;
    }


    .aboutUs_section1_column2_h3 {
        font-size: 22px !important;
    }

    .aboutUs_section1_column2_text2 {
        font-weight: 400;
        font-size: 13px;
        line-height: 35px;
        width: 280px;
        margin-bottom: 60px;
    }

    .policy_text2 {
        font-size: 14px;
    }



    /* Start Here*/

    .aboutUs_section2_column1 {
        width: 100%;
        height: 155px;
        padding-top: 20px;
    }

    .aboutUs_section2_column1h4 {
        font-weight: 700;
        font-size: 17px;
        line-height: 32px;
        width: 340px;
        height: 96px;
    }


    .aboutUs_section3_container {
        padding: 0 30px;
    }

    .aboutUs_section3Head_common {
        font-size: 15px;
    }

    .aboutUs_section3Text_common {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        width: 280px;
        height: 48px
    }

}

@media screen and (max-width: 330px) {


    .aboutUs_section1_column1 {
        height: 320px !important;
    }

    .aboutUs_section1_heading,
    .aboutUs_section1_column2_text1,
    .aboutUs_section2_column1p,
    .aboutUs_section3_part1p {
        font-size: 15px !important;
    }


    .aboutUs_section1_column1_flexh3 {
        font-size: 16px !important;
    }

    .aboutUs_section1_column1_flexp {
        font-size: 13px !important;
    }


    .aboutUs_section2_column1 {
        width: 100%;
        height: 170px;
        padding-top: 50px;
    }

    .aboutUs_section2_column1h4 {
        font-weight: 700;
        font-size: 15px;
        line-height: 32px;
        width: 290px;
        height: 70px;
    }


    .aboutUs_section1_column2_h3 {
        font-size: 20px;
    }

    .aboutUs_section1_column2_text2 {
        font-size: 13px;
        width: 270px;
        margin-bottom: 60px;
    }

    .policy_text2 {
        font-size: 13px;
    }

    .aboutUs_section3_container {
        padding: 0 20px;
    }

    .aboutUs_section3Head_common {
        font-size: 14px;
    }

    .aboutUs_section3Text_common {
        font-size: 12px;
        width: 230px;
    }

    .aboutUs_section4_container {
        height: 2280px;
    }


}`, "",{"version":3,"sources":["webpack://./src/styles/AboutUs.css"],"names":[],"mappings":"AAAA;IACI,cAAc;;AAElB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,yDAA6D;IAC7D,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;;IAII,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;;AAEjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,UAAU;;AAEd;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,6DAA6D;QAC7D,YAAY;IAChB;;;IAGA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;;IAEvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,aAAa;IACjB;;;IAGA,cAAc;;IAEd;QACI,aAAa;QACb,yBAAyB;QACzB,eAAe;;IAEnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI;QACI,0BAA0B;;IAE9B;;IAEA;;;;QAII,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,aAAa;;IAEjB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;IAGA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;;IAEvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,yBAAyB;QACzB,yBAAyB;QACzB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mDAAmD;QACnD,8BAA8B;QAC9B,wBAAwB;QACxB,sBAAsB;QACtB,wBAAwB;QACxB,iCAAiC;;IAErC;;IAEA;;;;QAII,2BAA2B;QAC3B,0BAA0B;QAC1B,+BAA+B;QAC/B,yBAAyB;;IAE7B;;;IAGA;QACI,wBAAwB;QACxB,iCAAiC;QACjC,sCAAsC;;IAE1C;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,0BAA0B;QAC1B,+BAA+B;QAC/B,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;;IAEf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,mBAAmB;;IAEvB;;IAEA;QACI,eAAe;IACnB;;IAEA,cAAc;;;IAGd;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,6DAA6D;QAC7D,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;;IAGA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;;IAExB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;;;IAGA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;;IAExB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;IACf;;;AAGJ;;;AAGA;;IAEI;QACI,yBAAyB;QACzB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;;;QAII,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;;IAE9B;;IAEA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;;;IAIA,cAAc;;IAEd;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ;IACJ;;AAEJ;;AAEA;;;IAGI;QACI,wBAAwB;IAC5B;;IAEA;;;;QAII,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;;AAGJ","sourcesContent":[".aboutUs_container {\n    color: #FFFFFF;\n\n}\n\n.aboutUs_section1_container {\n    background-color: #012D01;\n    /* height: 1000px; */\n    background-image: url('../Assets/Images/aboutus-hreo-bg.svg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding: 40px 50px 50px 50px;\n    z-index: 3;\n}\n\n.aboutUs_section1_column1 {\n    background-color: rgba(92, 191, 20, 0.4);\n    border-radius: 15px;\n    height: 220px;\n    padding: 0 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-top: 70px;\n}\n\n.aboutUs_section1_heading,\n.aboutUs_section1_column2_text1,\n.aboutUs_section2_column1p,\n.aboutUs_section3_part1p {\n    font-weight: 400 !important;\n    font-size: 20px !important;\n    line-height: 24.46px !important;\n    color: #EAAD11 !important;\n}\n\n.aboutUs_section1_column1_flex {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.aboutUs_section1_column1_flexh3 {\n    font-weight: 700 !important;\n    font-size: 48px !important;\n    line-height: 65px !important;\n    color: #FFFFFF !important;\n}\n\n.aboutUs_section1_column1_flexp {\n    width: 550px !important;\n    font-weight: 700 !important;\n    font-size: 18px !important;\n    line-height: 27.52px !important;\n    color: #FFFFFF !important;\n}\n\n.aboutUs_section1_column2 {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 722px;\n    height: 408px;\n    margin: auto;\n    padding-top: 100px;\n}\n\n.policy_row {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    /* height: 408px; */\n    margin: auto;\n    padding-top: 30px;\n}\n\n.policy_text2 {\n    display: flex;\n    font-size: 18px;\n    line-height: 35px;\n    width: 100%;\n    text-align: left;\n   \n}\n\n.aboutUs_section1_column2_h3 {\n    font-weight: 700;\n    font-size: 48px;\n    list-style: 60px;\n    padding-top: 10px;\n    padding-bottom: 20px;\n}\n\n.aboutUs_section1_column2_text2 {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 35px;\n    width: 722px;\n    height: 280px;\n\n}\n\n.aboutUs_section2_container {\n    display: flex;\n    padding-top: 150px;\n    gap: 50px;\n}\n\n.aboutUs_section2_column1 {\n    width: 424px;\n    height: 203px;\n}\n\n.aboutUs_section2_column1h4 {\n    font-weight: 400;\n    font-size: 30px;\n    line-height: 55px;\n    width: 424px;\n    height: 165px;\n}\n\n.abouthr_line {\n    width: 271px;\n    height: 6px;\n    border-radius: 15px;\n    background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);\n    border: none;\n}\n\n.aboutUs_section2_column2 {\n    display: flex;\n    gap: 20px;\n}\n\n.aboutusgallery2_img {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n\n.aboutusCustosolu_container {\n    display: flex;\n    gap: 10px;\n}\n\n.aboutusgallery2Head_common {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 33.1px;\n\n}\n\n.aboutusgallery2Text_common {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    width: 401px;\n    height: 112px;\n}\n\n.aboutUs_section3_container {\n    height: 550px;\n    background-color: #033d03;\n    position: relative;\n    padding: 0 50px;\n}\n\n.aboutUs_section3_part1_container {\n    width: 598px;\n    height: 417px;\n    padding-top: 60px;\n}\n\n.aboutUs_section3 {\n    padding-top: 50px;\n}\n\n.aboutUs_section3Head_common {\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 55px;\n\n}\n\n.aboutUs_section3Text_common {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    width: 541px;\n    height: 24px\n}\n\n.aboutUs_section4_container {\n    height: 860px;\n    background-color: #012D01;\n    padding: 0 50px;\n\n}\n\n.aboutUs_section4_part1 {\n    width: 402px;\n    height: 109px;\n    padding-top: 70px;\n\n}\n\n.aboutUs_section4_part1p {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px;\n    color: #EAAD11;\n}\n\n.aboutUs_section4_part1h4 {\n    font-size: 36px;\n    font-weight: 700;\n    line-height: 55px;\n\n}\n\n.aboutUs_section4_part2_gallery {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    padding-top: 150px;\n    padding-bottom: 100px;\n}\n\n.aboutUs_section4_part2_gallery_container {\n    position: relative;\n    overflow: hidden;\n    border-radius: 15px;\n}\n\n\n.aboutUs_section4_img_wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.aboutUs_section4_img_wrapper img {\n    border-radius: 14px;\n    width: 100%;\n}\n\n.aboutUs_section4_img_overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    opacity: 0;\n    transition: height 0.8s ease, opacity 0.8s ease;\n}\n\n.aboutUs_section4_part2_gallery_container:hover .aboutUs_section4_img_overlay {\n    height: 100%;\n    /* Increase the height to 100% on hover */\n    opacity: 1;\n\n}\n\n.aboutUs_section4_img_overlay_text {\n    background-color: #EAAD11;\n    color: #000000;\n    width: 100%;\n    overflow: hidden;\n    text-align: center;\n    height: 30%;\n    padding: 20px 0;\n\n}\n\n.aboutUs_section4_img_overlay_texth3 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n}\n\n.aboutUs_section4_img_overlay_textp {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-transform: uppercase;\n}\n\n.aboutusBtn_container {\n    width: 196px;\n    margin: auto;\n}\n\n\n@media screen and (max-width: 1050px) {\n    .aboutUs_section2_container {\n        display: flex;\n        padding-top: 150px;\n        gap: 20px;\n    }\n\n    .aboutUs_section2_column1 {\n        width: 350px;\n        height: 203px;\n    }\n\n    .aboutUs_section2_column1h4 {\n        font-weight: 400;\n        font-size: 24px;\n        line-height: 55px;\n        width: 320px;\n    }\n\n    .abouthr_line {\n        width: 251px;\n        height: 6px;\n        border-radius: 15px;\n        background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);\n        border: none;\n    }\n\n\n    .aboutusgallery2_img {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .aboutusgallery1_img img {\n        width: 270px;\n    }\n\n    .aboutusgallery2_img_aboutgallery2_img {\n        width: 280px;\n    }\n\n    .aboutus_custo_col {\n        width: 220px;\n    }\n\n    .aboutus_custo_img {\n        width: 35px;\n        height: 35px;\n    }\n\n    .aboutusCustosolu_container {\n        display: flex;\n    }\n\n    .aboutusgallery2Head_common {\n        font-weight: 700;\n        font-size: 23px;\n        line-height: 33.1px;\n\n    }\n\n    .aboutusgallery2Text_common {\n        font-weight: 400;\n        font-size: 17px;\n        line-height: 26.52px;\n        width: 240px;\n        height: 112px;\n    }\n\n\n    /* Section 4 */\n\n    .aboutUs_section4_container {\n        height: 800px;\n        background-color: #012D01;\n        padding: 0 50px;\n\n    }\n\n    .aboutUs_section4_part2_gallery img {\n        width: 170px;\n    }\n\n    .aboutUs_section4_img_overlay_texth3 {\n        font-size: 15px;\n    }\n\n    .aboutUs_section4_img_overlay_textp {\n        font-size: 15px;\n    }\n\n    .aboutUs_section4_img_overlay_text {\n        height: 38%;\n        padding: 15px 0;\n    }\n\n\n}\n\n@media screen and (max-width: 900px) {\n\n    .aboutUs_section1_column1 {\n        padding: 0 20px !important;\n\n    }\n\n    .aboutUs_section1_heading,\n    .aboutUs_section1_column2_text1,\n    .aboutUs_section2_column1p,\n    .aboutUs_section3_part1p {\n        font-size: 14px !important;\n    }\n\n    .aboutUs_section1_column1_flexh3 {\n        font-size: 30px !important;\n    }\n\n    .aboutUs_section1_column1_flexp {\n        width: 400px !important;\n        font-size: 15px !important;\n    }\n\n    .aboutUs_section1_column2 {\n        width: 522px;\n    }\n\n    .aboutUs_section1_column2_h3 {\n        font-size: 30px;\n    }\n\n    .aboutUs_section1_column2_text2 {\n        font-size: 16px;\n        width: 622px;\n    }\n\n\n    .aboutUs_section2_container {\n        gap: 30px;\n    }\n\n    .aboutUs_section2_column1 {\n        width: 230px;\n        height: 300px;\n    }\n\n    .aboutUs_section2_column1h4 {\n        font-size: 18px;\n        line-height: 48px;\n        width: 230px;\n        height: 160px;\n\n    }\n\n    .abouthr_line {\n        width: 180px;\n    }\n\n\n    .aboutusgallery1_img img {\n        width: 190px;\n    }\n\n    .aboutusgallery2_img_aboutgallery2_img {\n        width: 210px;\n    }\n\n    .aboutus_custo_col {\n        width: 170px;\n    }\n\n    .aboutus_custo_img {\n        width: 31px;\n        height: 33px;\n    }\n\n\n    .aboutusgallery2Head_common {\n        font-weight: 700;\n        font-size: 17px;\n        line-height: 31.1px;\n\n    }\n\n    .aboutusgallery2Text_common {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 24.52px;\n        width: 170px;\n        height: 170px;\n    }\n\n    .aboutUs_section4_container {\n        height: 660px;\n\n    }\n\n    .aboutUs_section4_part1p {\n        font-size: 16px;\n\n    }\n\n    .aboutUs_section4_part1h4 {\n        font-size: 30px;\n\n    }\n\n    .hr_rule_dir {\n        width: 200px;\n    }\n\n    .aboutUs_section4_part2_gallery img {\n        width: 120px;\n    }\n\n    .aboutUs_section4_img_overlay_texth3 {\n        font-size: 12px;\n    }\n\n    .aboutUs_section4_img_overlay_textp {\n        font-size: 12px;\n    }\n\n    .aboutUs_section4_img_overlay_text {\n        height: 45%;\n        padding: 5px;\n    }\n\n}\n\n@media screen and (max-width: 500px) {\n\n    .aboutUs_section1_container {\n        background-color: #012D01;\n        height: 1550px !important;\n        padding: 30px !important;\n    }\n\n    .privacy_policy_container {\n        height: 100% !important;\n    }\n\n    .aboutUs_section1_column1 {\n        background-color: rgba(92, 191, 20, 0.4) !important;\n        border-radius: 15px !important;\n        height: 244px !important;\n        width: 100% !important;\n        display: flex !important;\n        flex-direction: column !important;\n\n    }\n\n    .aboutUs_section1_heading,\n    .aboutUs_section1_column2_text1,\n    .aboutUs_section2_column1p,\n    .aboutUs_section3_part1p {\n        font-weight: 400 !important;\n        font-size: 16px !important;\n        line-height: 24.46px !important;\n        color: #EAAD11 !important;\n\n    }\n\n\n    .aboutUs_section1_column1_flex {\n        display: flex !important;\n        flex-direction: column !important;\n        justify-content: flex-start !important;\n\n    }\n\n    .aboutUs_section1_column1_flexh3 {\n        font-weight: 700 !important;\n        font-size: 23px !important;\n        line-height: 65px !important;\n        width: 100% !important;\n    }\n\n    .aboutUs_section1_column1_flexp {\n        width: 300px !important;\n        font-weight: 700 !important;\n        font-size: 14px !important;\n        line-height: 21.41px !important;\n        width: 100% !important;\n    }\n\n    .aboutUs_section1_column2 {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n\n    }\n\n    .aboutUs_section1_column2_h3 {\n        font-weight: 700;\n        font-size: 24px;\n        list-style: 60px;\n        padding-top: 10px;\n        padding-bottom: 20px;\n    }\n\n    .aboutUs_section1_column2_text2 {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 35px;\n        width: 100%;\n        margin-bottom: 50px;\n\n    }\n\n    .policy_text2 {\n        font-size: 16px;\n    }\n\n    /* Start Here*/\n\n\n    .aboutUs_section2_container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding-top: 150px;\n        gap: 0px;\n        /* margin-top: 30px; */\n    }\n\n    .aboutUs_section2_column1 {\n        width: 100%;\n        height: 155px;\n    }\n\n    .aboutUs_section2_column1h4 {\n        font-weight: 700;\n        font-size: 19px;\n        line-height: 32px;\n        width: 370px;\n        height: 96px;\n    }\n\n    .abouthr_line {\n        width: 138px;\n        height: 6px;\n        border-radius: 15px;\n        background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);\n        border: none;\n    }\n\n    .aboutusgallery1_img img {\n        display: none;\n    }\n\n    .aboutusgallery2_img_aboutgallery2_img {\n        width: 100%;\n    }\n\n    .aboutUs_section2_column2 {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        /* width: 100%; */\n    }\n\n    .aboutusgallery2_img {\n        display: flex;\n        flex-direction: column;\n        gap: 40px;\n    }\n\n\n    .aboutusCustosolu_container {\n        display: flex;\n        gap: 10px;\n    }\n\n    .aboutus_custo_col {\n        width: 100%;\n    }\n\n    .aboutusgallery2Head_common {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24.82px;\n\n    }\n\n    .aboutusgallery2Text_common {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        width: 100%;\n        height: 96px;\n    }\n\n\n    .aboutUs_section3_part1_container {\n        width: 598px;\n        height: 417px;\n        padding-top: 60px;\n    }\n\n    .aboutUs_section3 {\n        padding-top: 50px;\n        height: 130px;\n    }\n\n    .aboutUs_section3Head_common {\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 24.82px;\n\n    }\n\n    .aboutUs_section3Text_common {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        width: 300px;\n        height: 48px\n    }\n\n    .aboutUs_section4_container {\n        height: 2270px;\n        background-color: #012D01;\n        padding: 0 30px;\n    }\n\n    .aboutUs_section4_part1 {\n        width: 100%;\n    }\n\n    .aboutUs_section4_part1p {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24.46px;\n        color: #EAAD11;\n        text-align: center;\n    }\n\n    .aboutUs_section4_part1h4 {\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 55px;\n        text-align: center;\n    }\n\n    .hr_rule_dir {\n        width: 160px;\n        margin: auto;\n    }\n\n    .aboutUs_section4_part2_gallery {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        padding-top: 150px;\n        padding-bottom: 100px;\n        width: 100%;\n    }\n\n    .aboutUs_section4_img_wrapper img {\n        width: 100%;\n    }\n\n    .aboutUs_section4_img_overlay_text {\n        background-color: #EAAD11;\n        color: #000000;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n        height: 30%;\n        padding: 20px 0;\n    }\n\n    .aboutUs_section4_img_overlay_texth3 {\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 24px;\n    }\n\n    .aboutUs_section4_img_overlay_textp {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        text-transform: uppercase;\n    }\n\n    .aboutUs_section4_img_wrapper_img {\n        width: 100%;\n    }\n\n\n}\n\n\n@media screen and (max-width: 400px) {\n\n    .aboutUs_section1_container {\n        background-color: #012D01;\n        height: 1500px;\n        padding: 30px;\n    }\n\n    .aboutUs_section1_column1 {\n        height: 300px !important;\n    }\n\n    .aboutUs_section1_heading,\n    .aboutUs_section1_column2_text1,\n    .aboutUs_section2_column1p,\n    .aboutUs_section3_part1p {\n        font-size: 15px !important;\n    }\n\n\n    .aboutUs_section1_column1_flexh3 {\n        font-size: 18px !important;\n\n    }\n\n    .aboutUs_section1_column1_flexp {\n        font-size: 13px !important;\n    }\n\n\n    .aboutUs_section1_column2_h3 {\n        font-size: 22px !important;\n    }\n\n    .aboutUs_section1_column2_text2 {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 35px;\n        width: 280px;\n        margin-bottom: 60px;\n    }\n\n    .policy_text2 {\n        font-size: 14px;\n    }\n\n\n\n    /* Start Here*/\n\n    .aboutUs_section2_column1 {\n        width: 100%;\n        height: 155px;\n        padding-top: 20px;\n    }\n\n    .aboutUs_section2_column1h4 {\n        font-weight: 700;\n        font-size: 17px;\n        line-height: 32px;\n        width: 340px;\n        height: 96px;\n    }\n\n\n    .aboutUs_section3_container {\n        padding: 0 30px;\n    }\n\n    .aboutUs_section3Head_common {\n        font-size: 15px;\n    }\n\n    .aboutUs_section3Text_common {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 24px;\n        width: 280px;\n        height: 48px\n    }\n\n}\n\n@media screen and (max-width: 330px) {\n\n\n    .aboutUs_section1_column1 {\n        height: 320px !important;\n    }\n\n    .aboutUs_section1_heading,\n    .aboutUs_section1_column2_text1,\n    .aboutUs_section2_column1p,\n    .aboutUs_section3_part1p {\n        font-size: 15px !important;\n    }\n\n\n    .aboutUs_section1_column1_flexh3 {\n        font-size: 16px !important;\n    }\n\n    .aboutUs_section1_column1_flexp {\n        font-size: 13px !important;\n    }\n\n\n    .aboutUs_section2_column1 {\n        width: 100%;\n        height: 170px;\n        padding-top: 50px;\n    }\n\n    .aboutUs_section2_column1h4 {\n        font-weight: 700;\n        font-size: 15px;\n        line-height: 32px;\n        width: 290px;\n        height: 70px;\n    }\n\n\n    .aboutUs_section1_column2_h3 {\n        font-size: 20px;\n    }\n\n    .aboutUs_section1_column2_text2 {\n        font-size: 13px;\n        width: 270px;\n        margin-bottom: 60px;\n    }\n\n    .policy_text2 {\n        font-size: 13px;\n    }\n\n    .aboutUs_section3_container {\n        padding: 0 20px;\n    }\n\n    .aboutUs_section3Head_common {\n        font-size: 14px;\n    }\n\n    .aboutUs_section3Text_common {\n        font-size: 12px;\n        width: 230px;\n    }\n\n    .aboutUs_section4_container {\n        height: 2280px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
